const revealSelector = '[data-ow-reveal]';
const meterSelector = '[data-ow-meter]';

function easeOutCubic(progress) {
  return 1 - Math.pow(1 - progress, 3);
}

function markVisible(element) {
  element.classList.add('is-visible');
}

function initReveals(root, reduceMotion) {
  const reveals = Array.from(root.querySelectorAll(revealSelector));

  reveals.forEach((element, index) => {
    if (!element.style.getPropertyValue('--ow-delay')) {
      element.style.setProperty('--ow-delay', `${Math.min(index * 90, 360)}ms`);
    }
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(markVisible);
    return;
  }

  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        markVisible(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.14,
      rootMargin: '0px 0px -12% 0px',
    }
  );

  reveals.forEach((element) => {
    if (!element.classList.contains('is-visible')) {
      revealObserver.observe(element);
    }
  });
}

function animateMeter(meter, reduceMotion) {
  if (meter.dataset.owAnimated === 'true') return;

  meter.dataset.owAnimated = 'true';

  const target = Number(meter.dataset.target || 214);
  const lineMax = Number(meter.dataset.lineMax || 0.67);
  const suffix = meter.dataset.suffix || 'm';
  const duration = reduceMotion ? 0 : 1800;
  const badge = meter.querySelector('[data-ow-meter-badge]');

  if (!badge) return;

  const render = (progress) => {
    const eased = easeOutCubic(progress);
    meter.style.setProperty('--ow-meter-progress', `${eased * lineMax}`);
    badge.textContent = `${Math.round(target * eased)}${suffix}`;
  };

  if (duration === 0) {
    render(1);
    return;
  }

  const start = performance.now();

  const frame = (now) => {
    const progress = Math.min((now - start) / duration, 1);
    render(progress);

    if (progress < 1) {
      requestAnimationFrame(frame);
    }
  };

  requestAnimationFrame(frame);
}

function initMeters(root, reduceMotion) {
  const meters = Array.from(root.querySelectorAll(meterSelector));

  meters.forEach((meter) => {
    if (meter.dataset.owPrepared === 'true') return;

    meter.dataset.owPrepared = 'true';

    if (reduceMotion) return;

    meter.style.setProperty('--ow-meter-progress', '0');

    const badge = meter.querySelector('[data-ow-meter-badge]');

    if (badge) {
      badge.textContent = `0${meter.dataset.suffix || 'm'}`;
    }
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    meters.forEach((meter) => animateMeter(meter, reduceMotion));
    return;
  }

  const meterObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateMeter(entry.target, reduceMotion);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
    }
  );

  meters.forEach((meter) => meterObserver.observe(meter));
}

function initOurWaterPage() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pages = Array.from(document.querySelectorAll('[data-our-water-page]'));

  pages.forEach((page) => {
    if (page.dataset.owPageReady === 'true') return;

    page.dataset.owPageReady = 'true';
    page.classList.add('our-water-page--enhanced');

    initReveals(page, reduceMotion);
    initMeters(page, reduceMotion);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOurWaterPage, { once: true });
} else {
  initOurWaterPage();
}

document.addEventListener('shopify:section:load', initOurWaterPage);
